import http from "./axios";

const queryPage = ({ pageSize, pageNo, channel, platformId }) => {
  return http.get("/manager/paramAppoint/channelPlatformBlacklist", {
    pageSize,
    pageNo,
    channel,
    platformId,
  });
};

const channelList = ({ channel }) => {
  return http.get("/manager/enum/channelList", { channel });
};

const addData = ({ channel, platformId }) => {
  return http.json_post("/manager/paramAppoint/addChannelPlatformBlacklist", {
    channel,
    platformId,
  });
};

const deleteData = ({ id }) => {
  return http.json_post(
    "/manager/paramAppoint/deleteChannelPlatformBlacklist",
    { id }
  );
};

export default {
  queryPage,
  channelList,
  deleteData,
  addData,
};
